export const Spinner = require('react-spinkit') // eslint-disable-line
